<template>
  <HgNotificationMessage theme="info" :title="$t('location.alternative_addresses_title')">
    <div>{{ $t('location.alternative_addresses_suggestion') }}</div>
    <ul>
      <li
        v-for="(alternative, index) in locationAlternatives"
        :key="`alt_location_${index}`"
        style="cursor: pointer; text-decoration: underline"
        @click="emit('onSelectAlternative', alternative)"
      >
        {{ alternative.formattedAddress }}
      </li>
    </ul>
  </HgNotificationMessage>
</template>
<script setup lang="ts">
import { usePropertyValuationStore } from '@/stores/propertyValuation';
import { Location } from '@/stores/types/propertyValuation';
import { HgNotificationMessage } from '@smg-real-estate/domus';
import { storeToRefs } from 'pinia';

const propertyValuationStore = usePropertyValuationStore();
const { locationAlternatives } = storeToRefs(propertyValuationStore);
const emit = defineEmits<{
  (e: 'onSelectAlternative', alternative: Location): void;
}>();
</script>
